import React from "react";

export interface AnnotationProps {
  id: string;
}

export const Annotation: React.FC<AnnotationProps> = () => {
  return <></>;
};
